<template>
  <div :id="this.id" class="sitebuilder-element-container" @contextmenu.prevent="handler($event)"
    element="FloatingButtonComponent" :config-properties="JSON.stringify(internal_config)" :style="style()"
    v-on:click="focusElement($event)" :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.width)" @resizing="onResize"
      :draggable="false">
      <sync-drag :target="this" />

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-FloatingButtonComponent'></options-element-bar>

      <div class="floating-button">
        <a :href="internal_config.href">
          <img class="floating-button-image" ref="image"
            :src="require(`@/assets/icons/floating-button/${internal_config.type}.png`)"
            v-bind:style="{ 'opacity': opacity, 'width': width, 'height': width, 'border-radius': '100%', 'box-shadow': internal_config.boxShadow, }" />
        </a>
        <a v-if="internal_config.callToAction.enable == true" class="call-to-action call-to-action-animation"
          :href="internal_config.href" :class="internal_config.right === false ? 'left' : 'right'">
          <div class="call-to-action-text">{{ internal_config.callToAction.text }}</div>
        </a>
      </div>

    </vue-draggable-resizable>

  </div>
</template>

<script>

import Data from './Model';
import OptionsElementBar from '../OptionsElementBar';
import MixinComponents from "../../../../js/mixins/MixinComponents";


export default {
  name: 'FloatingButtonComponent',
  props: ['config', 'id', 'preview'],
  mixins: [MixinComponents],
  components: {
    OptionsElementBar
  },
  data() {
    return Data.data()
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    },
  },
  methods: {
    animation() {
      return true;
    },

    onResize: function (x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    build(config) {
      this.internal_config = config;
    },
    style() {
      var style = `width: ${this.internal_config.width} !important;
                     height:  ${this.internal_config.height} !important;
                     z-index: 9999;
                     ${this.internal_config.right === true ? 'right' : 'left'}:  0 !important;
                     bottom: 20px !important;
                     border-radius: 100% !important;
                     position: fixed !important;
                     `
      return style;
    },


    styleResize() {
      return `{width: ${this.internal_config.width}, height: auto}`;
    },
  },
  computed: {
    
    opacity() {
      return this.internal_config.opacity;
    },
    width() {
      return this.internal_config.width;
    },
  },
  created() {
    this.build(this.$props.config);

    this.internal_config = window.mergeRecursive(this.props, this.$props.config);
  },
  mounted() {
    
    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

      // $(this.$refs.image).atvImg();
    }

    let objIds = [];
    $('[id]').each(function () {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    // this.$refs.resourcesData.setValuesData(this);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

[data-device="desktop"] #editor-content .sitebuilder-element-container {
  top: auto !important;
  left: auto !important;
  margin-left: 20px !important;
  margin-right: 40px !important;
  padding: 0 !important;
  max-width: initial !important;
}

[data-device="tablet"] #editor-content .sitebuilder-element-container {
  top: auto !important;
  left: auto !important;
  padding: 0 !important;
  margin-left: 30% !important;
  margin-right: 30% !important;
  max-width: initial !important;
}

[data-device="mobile"] #editor-content .sitebuilder-element-container {
  left: auto !important;
  top: auto !important;
  padding: 0 !important;
  margin-left: 42% !important;
  margin-right: 42% !important;
  max-width: initial !important;

}


.floating-button {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  -webkit-box-pack: start;
  justify-content: flex-start;
  align-items: center;
}

.floating-button-image {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
}

.resizable.vdr {
  width: 100% !important;
  height: auto !important;
}

.call-to-action {
  box-shadow: rgba(136, 136, 136, 0.4) 0px 1px 7px;
  flex-shrink: 0;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 5px;
  background: white;
  cursor: pointer;
  /* max-width: 172px; */
  max-height: 100px;
  display: flex;
  order: 2;
  text-decoration: none !important;
  color: rgb(0, 0, 0) !important;
}

.left {
  left: calc(100% + 20px);
}

.right {
  right: calc(100% + 20px);
}

.call-to-action::before,
.call-to-action::after {
  content: "";
  position: absolute;
  background: white;
  top: 50%;
  margin-top: -4px;
  width: 8px;
  height: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}

.call-to-action.left::after,
.call-to-action.left::before {
  border-top: 1px solid rgb(226, 226, 226);
  border-left: 1px solid rgb(226, 226, 226);
  left: -5px;
}

.call-to-action.right::after,
.call-to-action.right::before {
  border-right: 1px solid rgb(226, 226, 226);
  right: -5px;
}

.call-to-action-animation {
  transform: translateX(0px);
  position: absolute;
  animation-duration: 0.64s;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-delay: 0.16s;
  animation-fill-mode: backwards;
  animation-name: ijMbJr;
}

.call-to-action-text {
  text-align: center;
  padding: 10px 10px;
  line-height: 16px;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 14px;
  margin: auto;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/FloatingButton/FloatingButton.vue